import { routes as routesAlternatives } from "@Alternatives/Alternatives/routes";
import { routes as routesAlternativesLists } from "@Alternatives/AlternativesLists/routes";
import { routes as routesLists } from "@Alternatives/AlternativesViews/routes";
import { routes as routesAssignments } from "@Alternatives/Assignments/routes";
import { routes as routesAttributes } from "@Alternatives/Attributes/routes";
import { routes as routesForms } from "@Alternatives/Forms/routes";
import { routes as routesNotifications } from "@Alternatives/Notifications/routes";

export const routes = [
    ...routesAlternatives,
    ...routesAttributes,
    ...routesAlternativesLists,
    ...routesForms,
    ...routesAssignments,
    ...routesLists,
    ...routesNotifications,
]
